/**
 * Global /proscons page. EvaluationPickerSheet → on pick → ProsConsWorkspace
 * (the H1 column-per-site component) inside the shared module-page chrome.
 * URL preserves the picked evaluation via `?eval=<id>` so reload + share-link
 * both work.
 *
 * Linear: MYD-224 (H2).
 *
 * Note on the "Sidebar Pros & Cons entry highlights" acceptance criterion:
 * per the user-locked sidebar IA (memory: feedback_sidebar_ia.md; canonical
 * implementation MYD-235), Pros & Cons is NOT a sidebar entry. The route
 * `/proscons` remains valid and deep-linkable, but no sidebar item highlights
 * for it. The acceptance bullet is superseded by the IA lock — confirmed in
 * the Linear comment thread on this issue (Bucket-1 IA-lock comment,
 * 2026-04-30).
 */

import EvaluationModulePage from './_EvaluationModulePage'
import ProsConsWorkspace from '../components/proscons/ProsConsWorkspace'

const ProsConsPage = () => (
	<EvaluationModulePage
		moduleName="Pros & Cons"
		moduleDescription="Pick an evaluation to capture per-site pros and cons with voting."
		workspacePhase="MYD-223 (H1)"
		workspaceHint="Column-per-site layout with pros / cons panels, impact level pills, and upvote tracking."
		renderWorkspace={(evalId) => <ProsConsWorkspace evalId={evalId} />}
	/>
)

export default ProsConsPage
